export default __webpack_public_path__ + "images/image9.794d702f.png";